import { createAction } from '@reduxjs/toolkit';

export const TOGGLE_MUTE_ACTION_TYPE = 'saga/toggleMute';
export const toggleMuteAction = createAction(TOGGLE_MUTE_ACTION_TYPE);
